(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["speelgoes-collection"]) return;
  try {
    
  const zetFilterrijVast = () => {
    const rij = document.querySelector('.collection-wrapper > .facets-toggle');
    if (!rij) return;
    const top = parseFloat(getComputedStyle(rij).top) || 0;
    rij.toggleAttribute('data-vast', window.scrollY > 0 && rij.getBoundingClientRect().top <= top + 1);
  };
  window.addEventListener('scroll', zetFilterrijVast, { passive: true });

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["speelgoes-zoek-ingang"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const zet = () => {
      const plek = document.querySelector('#search-modal .predictive-search-form__content-wrapper');
      const tpl = document.getElementById('spg-zi');
      if (!plek || !tpl || plek.querySelector('[data-spg-zi]')) return;
      plek.prepend(tpl.content.cloneNode(true));
      plek.querySelector('[data-spg-zi]').addEventListener('click', () => {
        try { window.Shopify?.analytics?.publish?.('spg_cadeauzoeker_ingang', { plaats: 'zoeken' }); } catch (_) { /* meten mag niets breken */ }
      });
      const cat = document.createElement('div');
      cat.dataset.spgZcPlek = '';
      plek.querySelector('[data-spg-zi]').after(cat);
      cat.addEventListener('click', (e) => {
        const a = e.target.closest('[data-spg-zc-link]');
        if (!a) return;
        try { window.Shopify?.analytics?.publish?.('spg_zoek_categorie', { categorie: a.dataset.spgZcLink }); } catch (_) {}
      });
      const veld = document.querySelector('#search-modal input[name="q"]');
      if (!veld) return;
      let wacht = 0;
      let lopend = null;
      const haal = () => {
        const q = veld.value.trim();
        if (lopend) lopend.abort();
        if (q.length < 2) { cat.innerHTML = ''; return; }
        lopend = new AbortController();
        const url = new URL((window.Shopify?.routes?.root || '/') + 'search/suggest', location.origin);
        url.searchParams.set('q', q);
        url.searchParams.set('section_id', 'speelgoes-zoek-categorie');
        fetch(url, { signal: lopend.signal })
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => {
            if (veld.value.trim() !== q) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const blok = doc.querySelector('[data-spg-zc]');
            cat.innerHTML = '';
            if (blok) cat.append(blok);
          })
          .catch(() => {});
      };
      veld.addEventListener('input', () => { clearTimeout(wacht); wacht = setTimeout(haal, 160); });
      if (veld.value.trim()) haal();
    };
    // Geen resultaten: een uitweg naar alle producten onder de melding (Horizon vervangt de resultaten bij elke toets).
    const leeg = () => {
      document.querySelectorAll('#search-modal .predictive-search-results__no-results').forEach((p) => {
        if (p.nextElementSibling?.matches('[data-spg-zi-alles]')) return;
        const a = document.createElement('a');
        a.className = 'spg-zi-alles';
        a.href = (window.Shopify?.routes?.root || '/') + 'collections/all';
        a.dataset.spgZiAlles = '';
        a.textContent = document.getElementById('spg-zi')?.dataset.alles || 'Bekijk alle producten';
        p.after(a);
      });
    };
    const start = () => {
      zet();
      const modal = document.getElementById('search-modal');
      if (modal) new MutationObserver(leeg).observe(modal, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();

  } catch(e) { console.error(e); }
})();
})();
